var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedRetailer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 322,
    viewBox: "0 0 273 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2657_552)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2657_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.646 87.7799L141.314 62.6072C140.161 62.2546 138.933 62.2546 137.78 62.6072L55.4467 87.7799C52.846 88.575 51.0647 91.015 51.0647 93.7825V186.082C51.0647 198.087 55.8337 210.377 65.2385 222.609C72.4213 231.951 82.359 241.332 94.7745 250.491C115.632 265.878 136.17 275.317 137.034 275.711C137.833 276.076 138.69 276.258 139.547 276.258C140.404 276.258 141.261 276.076 142.06 275.711C142.923 275.317 163.461 265.878 184.319 250.491C196.734 241.332 206.671 231.951 213.855 222.609C223.259 210.377 228.028 198.088 228.028 186.082V93.7825C228.028 91.015 226.247 88.575 223.646 87.7799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.391 53.6448C264.858 49.7447 262.105 46.5366 258.383 45.4822L139.091 1.15771C137.391 0.675311 135.594 0.675385 133.892 1.15778L14.6013 45.4822C10.8793 46.5366 8.12595 49.7434 7.59313 53.6448C6.90123 58.7152 -8.88312 178.519 31.6027 238.117C72.0406 297.645 131.695 312.9 134.214 313.52C134.963 313.705 135.726 313.796 136.492 313.796C137.258 313.796 138.021 313.704 138.769 313.52C141.29 312.9 200.945 297.645 241.381 238.117C281.867 178.52 266.083 58.7165 265.391 53.6448ZM213.419 123.587L132.051 206.514C130.158 208.443 127.674 209.409 125.193 209.409C122.711 209.409 120.228 208.445 118.334 206.514L68.025 155.241C66.2054 153.388 65.1837 150.873 65.1837 148.252C65.1837 145.63 66.2067 143.115 68.025 141.262L78.0142 131.082C81.8022 127.222 87.9439 127.221 91.7306 131.082L125.193 165.184L189.714 99.4265C191.532 97.572 194 96.5308 196.572 96.5308C199.144 96.5308 201.612 97.572 203.43 99.4265L213.419 109.607C217.207 113.467 217.207 119.727 213.419 123.587Z",
    fill: "url(#paint0_linear_2657_552)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2657_552",
    x: -0.00805664,
    y: 0.795898,
    width: 273,
    height: 321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2657_552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2657_552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2657_552",
    x: -0.00805664,
    y: 0.795898,
    width: 273,
    height: 321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2657_552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2657_552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2657_552",
    x1: 136.85,
    y1: 11.3104,
    x2: 136.85,
    y2: 313.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EA923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedRetailer);
export default __webpack_public_path__ + "static/media/verified-retailer.21e982c70488105c579edc468f1fb1af.svg";
export { ForwardRef as ReactComponent };